/*
 * Javascript for privacy policy (pretty much just scrollspy)
*/
(function domReady($) {
	if($('.table-of-contents').length) {
		//match col heights
		$('.toc-col').matchHeight();

		//Make sidebar sticky
		$('.sidebar').sticky();

		$('.toc-section').each(function eachElement() {
			// cache the jQuery object
			var $this = $(this);

			var position = $this.position();
			$this.scrollspy({
				buffer: -400,
				min: position.top,
				max: position.top + $this.height(),
				onEnter: function onEnter(element/*, position*/) {
					//$('.sidebar a[data-scroll-id="'+element.id+'"]').removeClass('current');
				},
				onEnter: function onLeave(element/*, position*/) {
					$('.sidebar a').removeClass('current');
					$('.sidebar a[data-scroll-id="'+element.id+'"]').addClass('current');
				}
			});
		});
		/*var sidebar = $('.sidebar');
		sidebar.scrollspy({
			onEnter: function(element, position) {
				sidebar.removeClass('fixed');
			},
			onLeave: function(element, position) {
				sidebar.addClass('fixed');
			}
		});*/
	}
})(jQuery);
